import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { DRUPAL_HOST } from 'utils/constants'

import introspectionQueryResultData from '../mobyGraphqlSchema.json'

const GRAPHQL_HOST = `${DRUPAL_HOST}/graphql`

const possibleTypes = {}
const { __schema: schema } = introspectionQueryResultData
if (schema && schema.types) {
  schema.types.forEach(supertype => {
    if (supertype.possibleTypes) {
      possibleTypes[supertype.name] = supertype.possibleTypes.map(subtype => subtype.name)
    }
  })
}

const create = () =>
  new ApolloClient({
    link: from([
      onError(({ graphQLErrors }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) =>
            console.error(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            ),
          )
        }
      }),
      new HttpLink({
        uri: GRAPHQL_HOST,
        credentials: 'include',
      }),
    ]),
    cache: new InMemoryCache({ possibleTypes }),
  })

let apolloClient = null

export default () => {
  if (!apolloClient) {
    apolloClient = create()
  }
  return apolloClient
}
